import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import styled from '@emotion/styled';
var MockWidget = styled.div(function (_ref) {
  var floating = _ref.floating;
  return _objectSpread({
    alignItems: 'center',
    backgroundColor: '#0064e2',
    borderRadius: '25px',
    color: 'white',
    display: 'flex',
    fontSize: '12px',
    height: '50px',
    justifyContent: 'center',
    overflow: 'visible',
    pointerEvents: 'auto',
    width: '146px'
  }, floating && {
    margin: '10px 20px',
    position: 'fixed',
    bottom: '0px',
    zIndex: 99,
    // allow real Zendesk widget to go on top with its zIndex 100
    right: '0px'
  });
});
function shouldHideMock() {
  return window.ENVIRONMENT === 'production';
}
export var MockZendeskWidget = function MockZendeskWidget(_ref2) {
  var _ref2$floating = _ref2.floating,
    floating = _ref2$floating === void 0 ? true : _ref2$floating;
  if (shouldHideMock()) {
    return /*#__PURE__*/React.createElement("div", {
      "aria-hidden": true,
      style: {
        height: 50,
        width: 1
      }
    }, "\xA0");
  }
  return /*#__PURE__*/React.createElement(MockWidget, {
    id: "mock-zendesk-widget",
    floating: floating
  }, "mock chat widget");
};